export default "__VITE_ASSET__c460a669__"